import React, { useCallback, useEffect, useState } from 'react';
import { Row } from 'reactstrap';

import Pagination from 'components/Pagination';
import Loader from 'components/Loader';

import FilterProductsForm from './components/FilterProductsForm';
import ListProductsTable from './components/ListProductsTable';

import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';

import { useListProducts } from '../../../hooks/useListProducts';

const ProductsList = ({
  selectedRecordTypeId,
  setSelectedRecordType,
  recordTypes
}) => {
  const [activePage, setActivePage] = useState(1);
  const [filters, setFilters] = useState({});

  const {
    getProducts,
    products,
    totalProducts,
    isLoadingProducts,
    clearProducts
  } = useListProducts({
    recordTypeId: selectedRecordTypeId
  });

  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.PRODUCT,
    selectedRecordTypeId
  );

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    clearProducts();
    setActivePage(1);
  }, [selectedRecordTypeId, clearProducts]);

  const handleSearch = useCallback(
    (searchFilters) => {
      setActivePage(1);
      setFilters(searchFilters);
      getProducts(1, searchFilters);
    },
    [getProducts, selectedRecordTypeId]
  );

  const handlePageChange = (newPage) => {
    setActivePage(newPage);
    getProducts(newPage, filters);
  };

  const reloadProducts = useCallback(() => {
    getProducts(1, {});
  }, [getProducts]);

  return (
    <>
      <FilterProductsForm
        handleSearch={handleSearch}
        customFields={customFields}
        isLoading={isLoadingProducts}
        selectedRecordTypeId={selectedRecordTypeId}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
        products={products}
        reloadProducts={reloadProducts}
      />

      <div className="d-block small px-2 mt-4 text-right">
        {totalProducts} resultado(s) encontrado(s)
      </div>
      <Row className="mt-2">
        {isLoadingProducts ? (
          <div className="col-12">
            <Row className="justify-content-md-center">
              <Loader />
            </Row>
          </div>
        ) : (
          <ListProductsTable
            products={products}
            reloadProducts={reloadProducts}
            customFields={customFields}
          />
        )}
      </Row>
      <Pagination
        activePage={activePage}
        totalItemsCount={totalProducts}
        onChange={handlePageChange.bind(this)}
      />
    </>
  );
};

export default ProductsList;
